// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CollaborationHistoryEnum {
  CollaborationEnabled = 0,
  ModifiedCollaborators = 1,
  Published = 2,
  OpportunityLinked = 3,
  OpportunityUnlinked = 4,
  ProposalGenerated = 5,
  CostReviewRequested = 6,
  ProductPromotion = 7,
  SAPSubmitted = 8,
  CollaborationDisabled = 9,
  PublishedFromMT = 10,
  SAPSubmittalUnlock = 11,
  OpportunityCreated = 12,
  OpportunityCreateFailed = 13,
  CostReviewUnlocked = 14,
  CostReviewAutoUnlocked = 15,
  OpportunityLinkFailed = 16,
  OpportunityUnlinkFailed = 17,
  CostReviewCancelled = 18,
  CostReviewerReplaced = 19,
  CostReviewerRemoved = 20,
  TurnoverToSales = 21,
  PriceRecommenderUsed = 22,
}
